import apiClient from './api';

/**
 * Service for testing API connectivity
 */
export class TestService {
  /**
   * Test if the API server is reachable
   * @returns Promise with the test result
   */
  async testConnection(): Promise<{ success: boolean; message: string; timestamp?: string }> {
    try {
      console.log('Testing API connection...');
      const result = await apiClient.get<{ success: boolean; message: string; timestamp: string }>('/ctem/ui/test');
      console.log('API connection test successful:', result);
      return result;
    } catch (error) {
      console.error('API connection test failed:', error);
      
      // Try different URLs to help diagnose the issue
      const altUrls = [
        '/health',
        '/',
        'http://localhost:8088/ctem/ui/test',
        'http://localhost:8088/ctem/ui/health'
      ];
      
      for (const url of altUrls) {
        try {
          console.log(`Trying alternative URL: ${url}`);
          const response = await fetch(url);
          const data = await response.json();
          console.log(`Alternative URL ${url} succeeded:`, data);
        } catch (altError) {
          console.error(`Alternative URL ${url} failed:`, altError);
        }
      }
      
      return {
        success: false,
        message: `Connection failed: ${error instanceof Error ? error.message : String(error)}`
      };
    }
  }
}

export const testService = new TestService();
export default testService;
